import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import { TextField, Button } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { authenticateUser, verifyAndSendToken, logout } from '../actions/users'
import Typography from '@material-ui/core/Typography'
import logo from '../images/logo.svg'
import queryString from 'query-string'
import i18n from '../i18n'

const styles = theme => ({
  progress: {
    margin: theme.spacing.unit * 2
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: '1rem'
  })
})

class SwitchAccount extends Component {
  queryParams = {}

  state = {
    email: null,
    password: null,
    isRedirecting: false
  }

  constructor (props) {
    super(props)
    this.classes = props.classes
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.logout()
  }

  onChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.value
    this.setState(state)
  }

  render () {
    const { self = {} } = this.props
    return (
      self.user
        ? (
          <div id='login'>
            <Grid
              container
              spacing={16}
              className='height100'
              alignItems='center'
              direction='column'
              justify='center'
            >
              <Grid item xs={12} sm={4} md={4} style={{ minWidth: '33.3%' }}>
                <Grid container justify='center'>
                  <img src={logo} height={50} alt='SmarterWX Identity Logo' />
                </Grid>
                <Paper elevation={4} className={this.classes.paper}>
                  <Typography variant='h6'>{i18n.switchAppPage.title}</Typography>
                  <form onSubmit={this.handleSubmit}>
                    <TextField
                      inputProps={{
                        readOnly: true
                      }}
                      type='email'
                      label={i18n.switchAppPage.originalEmailLabel}
                      margin='normal'
                      fullWidth
                      value={this.props.self.user.email || ''}
                    /><br />
                    <TextField
                      inputProps={{
                        readOnly: true
                      }}
                      type='email'
                      label={i18n.switchAppPage.newEmailLabel}
                      margin='normal'
                      fullWidth
                      value={queryString.parse(this.props.location.search).email}
                    /><br />
                    <Grid container spacing={24} alignItems='center'>
                      <Grid item xs={12} sm={12} md={12}>
                        <Typography variant='body2'><br />{i18n.switchAppPage.warning}</Typography>
                        <Button color='primary' variant='contained' type='submit'>{i18n.switchAppPage.comfirmButton}</Button>
                      </Grid>
                    </Grid>
                    <br />
                    <Grid container spacing={24} alignItems='center'>
                      <Grid item xs={12}>
                        <Typography variant='body2'><Link to='/appLauncher'>{i18n.switchAppPage.cancelButton}</Link></Typography>
                      </Grid>
                    </Grid>
                  </form>
                </Paper>
              </Grid>
            </Grid>
          </div>
          )
        : (
          <Redirect to={{
            pathname: '/login',
            search: this.props.location.search
          }}
          />
          )
    )
  }
}

const SwitchAccountComponent = withStyles(styles)(SwitchAccount)

function mapStateToProps (state) {
  return {
    self: state.self
  }
}

// Promote Login from a component to a container - it needs to know about this new dispatch method.
export default connect(mapStateToProps, { authenticateUser, verifyAndSendToken, logout })(SwitchAccountComponent)
